import styled from 'styled-components';

import InfoIconOutline from 'svg/InfoIconOutline';

type TimingExplainerProps = {
  jobType: 'summary' | 'comparison';
};

const TimingExplainer = ({ jobType }: TimingExplainerProps) => {
  return (
    <Container>
      <InfoIconOutline />
      <div>
        <span>Generating your {jobType} may take a few minutes.</span> The {jobType} will continue to generate in the
        background if you navigate away.
      </div>
    </Container>
  );
};

export default TimingExplainer;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  border: 1px solid rgba(89, 62, 228, 0.1);
  border-radius: 8px;
  width: 100%;
  padding: 20px;
  font-size: 12px;
  background: linear-gradient(
    270deg,
    rgba(107, 69, 184, 0.075) 0%,
    rgba(98, 65, 205, 0.0871438) 48.58%,
    rgba(89, 62, 228, 0.1) 100%
  );

  span {
    font-weight: bold;
  }

  svg {
    margin-right: 16px;
  }
`;
